/* eslint-disable camelcase */
import { notification } from 'antd'
import { all, takeEvery, put, call } from 'redux-saga/effects'
import * as jwt from 'services/jwt'
import actions from './actions'

const jwts = {
  getEventData: jwt.getEventData,
  setEventData: jwt.setEventData,
  getAccreditationData: jwt.getAccreditationData,
  setAccreditationData: jwt.setAccreditationData,
}

export function* GET_EVENT_DATA() {
  yield put({
    type: 'accreditation/SET_STATE',
    payload: {
      loading: true,
    },
  })
  const success = yield call(jwts.getEventData)
  if (success.status) {
    yield put({
      type: 'accreditation/SET_STATE',
      payload: {
        loading: false,
        eventData: success?.data,
      },
    })
  }
  if (!success.status) {
    yield put({
      type: 'accreditation/SET_STATE',
      payload: {
        loading: false,
      },
    })
    notification.error({message: "Error!", description: success?.message || "something went wrong"})
  }
}

export function* SET_EVENT_DATA({ payload }) {
  yield put({
    type: 'accreditation/SET_STATE',
    payload: {
      loading: true,
    },
  })
  const success = yield call(jwts.setEventData, payload)
  if (success.status) {
    yield put({
      type: 'accreditation/SET_STATE',
      payload: {
        loading: false,
      },
    })
    notification.success({message: "Success!", description: success?.message || "event successful"})
    yield put({ type: 'accreditation/GET_EVENT_DATA' })
  }
  if (!success.status) {
    yield put({
      type: 'accreditation/SET_STATE',
      payload: {
        loading: false,
      },
    })
    notification.error({message: "Error!", description: success?.message || "something went wrong"})
  }
}

export function* GET_ACCREDITATION_DATA() {
  yield put({
    type: 'accreditation/SET_STATE',
    payload: {
      loading: true,
    },
  })
  const success = yield call(jwts.getAccreditationData)
  if (success.status) {
    yield put({
      type: 'accreditation/SET_STATE',
      payload: {
        loading: false,
        accreditationData: success?.data,
      },
    })
  }
  if (!success.status) {
    yield put({
      type: 'accreditation/SET_STATE',
      payload: {
        loading: false,
      },
    })
    notification.error({message: "Error!", description: success?.message || "something went wrong"})
  }
}

export function* SET_ACCREDITATION_DATA({ payload }) {
  yield put({
    type: 'accreditation/SET_STATE',
    payload: {
      loading: true,
    },
  })
  const success = yield call(jwts.setAccreditationData, payload)
  if (success.status) {
    yield put({
      type: 'accreditation/SET_STATE',
      payload: {
        loading: false,
      },
    })
    notification.success({message: "Success!", description: success?.message || "accreditation successful"})
    yield put({ type: 'accreditation/GET_ACCREDITATION_DATA' })
  }
  if (!success.status) {
    yield put({
      type: 'accreditation/SET_STATE',
      payload: {
        loading: false,
      },
    })
    notification.error({message: "Error!", description: success?.message || "something went wrong"})
  }
}


export default function* rootSaga() {
  yield all([takeEvery(actions.GET_EVENT_DATA, GET_EVENT_DATA)])
  yield all([takeEvery(actions.SET_EVENT_DATA, SET_EVENT_DATA)])
  yield all([takeEvery(actions.GET_ACCREDITATION_DATA, GET_ACCREDITATION_DATA)])
  yield all([takeEvery(actions.SET_ACCREDITATION_DATA, SET_ACCREDITATION_DATA)])
}
